import { mapState } from "vuex";
import dayjs from "dayjs";
var numeral = require("numeral");
export default {
  computed: {
    ...mapState({
      clientHeight: state => state.clientHeight,
      userInfo: state => state.userInfo,
      unitInfo: state => state.unitInfo,
      org: state => state.org,
      unitAssetsInfo: state => state.unitAssetsInfo,
      roleMenu: state => state.roleMenu,
      operation_permission: state => state.operation_permission,
      permission: state => state.permission,
      globalYear: state => state.globalYear
    })
  },
  data() {
    return {
      needYear: "",
      timeFrame: ["2019-1-1", "2021-12-31"],
      timeRange: {
        disabledDate: time => {
          return (
            time.getTime() > new Date(this.timeFrame[1]) ||
            time.getTime() < new Date(this.timeFrame[0])
          );
        }
      }
    };
  },
  created() {
    this.needYear = this.$dayjs().subtract(1, "year").format("YYYY");
    // if (dayjs().month() === 1 && dayjs().date() > 1) {
    //   this.needYear = this.$dayjs().format("YYYY");
    // } else {
    //   this.needYear = this.$dayjs()
    //     .subtract(1, "year")
    //     .format("YYYY");
    // }
  },
  directives: {
    focus: {
      inserted: function(el) {
        el.focus();
      }
    }
  },
  methods: {
    channelInputLimit(e) {
      // 不允许输入'e'和 '+',限制输入长度整数加小数共16位
      if (e.key !== "Backspace" && Number(e.target.value) > 999999999999999) {
        e.returnValue = false;
        return false;
      }
      return true;
    },
    channelInputLimit1(e) {
      // 不允许输入'e'和 '+',限制输入长度整数加小数共16位
      if (
        (e.key !== "Backspace" && Number(e.target.value) > 999999999999999) ||
        e.key === "."
      ) {
        e.returnValue = false;
        return false;
      }
      return true;
    },
    floatToPercent(floatNumber) {
      // 百分号
      if (
        floatNumber === null ||
        floatNumber === undefined ||
        floatNumber === ""
      ) {
        return "";
      } else if (floatNumber == "0") {
        return "0%";
      } else {
        let floatString = `${Number(floatNumber * 100).toFixed(2)}%`;
        return floatString;
      }
    },

    // 判断为空
    valueIsNotNull(obj) {
      if (String(obj) === "0") {
        return true;
      } else if (!obj) {
        return false;
      } else {
        return true;
      }
    },

    tdHightLight() {
      // 单元格高亮
      let v = document.getElementById("table").querySelectorAll("input");

      v.forEach(o => {
        o.onfocus = function() {
          if (!o.parentElement.className.includes("wid-90")) {
            o.parentElement.parentElement.classList.add("tdActive");
            o.focus({
              preventScroll: true
            });
          }
        };
        o.onblur = function() {
          if (!o.parentElement.className.includes("wid-90")) {
            o.parentElement.parentElement.classList.remove("tdActive");
            o.blur({
              preventScroll: false
            });
          }

          v.forEach(o1 => {
            if (o1.value) {
              let v = "";
              let value = o1.value;
              let html = o1.parentElement.parentElement.parentElement.innerHTML;
              if (html.includes("<td>元</td>")) {
                v =
                  String(value) === "0" ? "0" : numeral(value).format("0,0.00");
                o1.parentElement.setAttribute("data-value", v);
                o1.parentElement.classList.add("showInput");
              } else if (
                html.includes("<td>人次</td>") ||
                html.includes("<td>人</td>") ||
                html.includes("<td>个</td>") ||
                html.includes("<td>次</td>") ||
                html.includes("<td>种</td>") ||
                html.includes("<td>份</td>")
              ) {
                v = String(value) === "0" ? "0" : numeral(value).format("0,0");
                o1.parentElement.setAttribute("data-value", v);
                o1.parentElement.classList.add("showInput");
              }
            } else {
              o1.parentElement.classList.remove("showInput");
            }
          });
        };
      });

      let v1 = document.querySelectorAll(".noBorderInput");

      v1.forEach(o => {
        o.onclick = function() {
          // chrome v49 不存在 classList.value
          console.time("class");
          if (
            o.classList.contains("is-disabled") ||
            o.parentElement.classList.contains("isCal")
          ) {
            return false;
          }
          console.timeEnd("class");
          o.querySelector("input").focus();
          o.classList.remove("showInput");
        };
      });
    },

    initFormatNum() {
      document.querySelectorAll(".noBorderInput").forEach(o => {
        let v = "";
        let value = o.querySelector("input")
          ? o.querySelector("input").value
          : o.innerText;
        let html = o.parentElement.parentElement.innerHTML;
        o.classList.remove("showInput");
        if (html.includes("<td>元</td>")) {
          v = String(value) === "0" ? "0" : numeral(value).format("0,0.00");
          if (value !== "") {
            o.setAttribute("data-value", v);
            o.classList.add("showInput");
          }
        } else if (
          html.includes("<td>人次</td>") ||
          html.includes("<td>人</td>") ||
          html.includes("<td>个</td>") ||
          html.includes("<td>次</td>") ||
          html.includes("<td>种</td>") ||
          html.includes("<td>份</td>")
        ) {
          v = String(value) === "0" ? "0" : numeral(value).format("0,0");
          if (value !== "") {
            o.setAttribute("data-value", v);
            o.classList.add("showInput");
          }
        }
      });
    },

    // formatNum(num, format) {
    //   var result = [],
    //     counter = 0;
    //   num = (num || 0).toString().split('');
    //   for (var i = num.length - 1; i >= 0; i--) {
    //     counter++;
    //     result.unshift(num[i]);
    //     if (!(counter % 3) && i != 0) { result.unshift(','); }
    //   }
    //   return ;
    // },

    formatTime(o) {
      return dayjs(o).format("YYYY-MM-DD");
    },

    // 生成报表详情的序号
    numberSerial(i, i1, obj) {
      let t = 1;
      for (var g = 0; g < i; g++) {
        t = t + Object.values(obj)[g].length;
      }
      return t + i1;
    },
    dialogBeforeClose() {
      console.log("12");
    },
    handlefileSuccess() {
      console.log("成功");
    },
    judgeEmpty(o) {
      // let a = Object.values(o).filter((o) => {
      //   return String(o).length >= 17
      // })

      // if (a.length > 0) {
      //   this.$notify({
      //     title: "温馨提示",
      //     message: "数据长度不能大于17位！",
      //     type: "error",
      //     position: "bottom-right"
      //   });
      //   return false
      // }

      if (
        Object.values(o).includes("") ||
        Object.values(o).includes(undefined)
      ) {
        this.$notify({
          title: "温馨提示",
          message: "含有空数据，请先完善表格数据！",
          type: "error",
          position: "bottom-right"
        });

        return false;
      } else {
        return true;
      }
    },
    beforefileUpload(file) {
      // let self = this;
      if (!file) {
        return false;
      }
      // console.log("file", file)
      // let params = new FormData();
      // params.append("file", file.file);
      // params.append("user_id", this.userInfo.user_id);
      // file.status = "uploading";
      // file.message = "上传中...";

      // this.$api.upload(params).then(res => {

      //   console.log("res", res)
      // });
    },
    // 过滤非事业单位
    excludeOtherCal(obj, i) {
      // 从父集开始怕判断
      // 0 行政单位
      // 7 事业单位
      // -1 为企业单位
      delete obj.unit_total;
      let a = {};
      Object.keys(obj).forEach(o => {
        a[o] = [];
        obj[o].forEach(o1 => {
          if (
            o1.table_data !== null &&
            o1.unit !== null &&
            o1.unit.father_property_type !== null &&
            i.includes(o1.unit.father_property_type)
          ) {
            a[o].push(o1);
          }
        });
      });
      return a;
    }
  }
};
